import { Skeleton } from '@/components/ui/skeleton';

export default function LoadingProductDetailPage() {
  return (
    <div className='theme_layout_space_section relative'>
      <div className='theme_layout_page_width mx-auto w-full py-8 md:py-16'>
        <div className='container mx-auto max-w-full px-4 md:max-w-screen-xl lg:px-16'>
          <div className='grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-16 lg:gap-16'>
            <div className='flex w-full justify-end'>
              <Skeleton className='h-[400px] w-full md:w-[400px]' />
            </div>
            <div className='flex w-full flex-col gap-4'>
              <Skeleton className='h-8 w-full' />
              <Skeleton className='h-8 w-[100px]' />
              <Skeleton className='h-12 w-[160px]' />
              <Skeleton className='h-6 w-[100px]' />
              <Skeleton className='h-14 w-full' />
              <Skeleton className='h-14 w-full' />
              <div className='grid grid-cols-2 gap-4'>
                <Skeleton className='h-8 w-full' />
                <Skeleton className='h-8 w-full' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
